export const SET_CURRENT_CASE = 'SET_CURRENT_CASE';
